import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { Program } from "../../API";
import { QueryStatus } from "../../app/types";

interface ProgramsSlice {
  programs?: Program[] | null;
  programsStatus: QueryStatus;
  programsError?: string;
}

const initialState: ProgramsSlice = {
  programs: [],
  programsStatus: "idle"
};

export const programsSlice = createSlice({
  name: "programs",
  initialState,
  reducers: {
    setPrograms: (
      state,
      action: PayloadAction<Program[] | null | undefined>
    ) => {
      state.programs = action.payload;
    },
    setProgramsStatus: (state, action: PayloadAction<QueryStatus>) => {
      state.programsStatus = action.payload;
    },
    setProgramsError: (state, action: PayloadAction<string | undefined>) => {
      state.programsError = action.payload;
    }
  }
});

export const { setPrograms, setProgramsStatus, setProgramsError } =
  programsSlice.actions;

export const selectPrograms = (state: RootState) =>
  state.programs.programs ?? [];
export const selectProgramsStatus = (state: RootState) =>
  state.programs.programsStatus;
export const selectProgramsError = (state: RootState) =>
  state.programs.programsError;

export default programsSlice.reducer;
